export enum GoodsSource {
  /** 消息列表 */
  Message = "sgMessage",
  /** 推荐列表 */
  Recommend = "sgRecomendation",
}
